import React from 'react';

export const ChatBubble = () => (
  <svg
    data-testid='chat-bubble'
    fill='none'
    height='96'
    viewBox='0 0 136 136'
    width='96'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M106 24.5H30C24.775 24.5 20.5 28.775 20.5 34V119.5L39.5 100.5H106C111.225 100.5 115.5 96.225 115.5 91V34C115.5 28.775 111.225 24.5 106 24.5ZM106 91H39.5L30 100.5V34H106V91Z'
      fill='#B4B7BB'
    />
  </svg>
);
